import styled from "styled-components";
import Col from "../../Shared/Kit/Col";
import { DarkColorConstruction, HexToRgba } from "../../Methods/HexToRgba";

export const HeaderWrapper = styled(Col)`
    width: 100vw;
    position: fixed;
    top: 0;
    right: 0;
    z-index: 2;
    padding: 20px 0;
`
export const Logo = styled(Col)`
    width: 150px;
    height: 60px;
    background-image: url(${(props) => props.source});
    background-size: contain;
    background-position: right;
    background-repeat: no-repeat;
    /* @media screen and (max-width: 1366px) {
        width: 140px;
        height: 55px;
    } */
`
export const MenuContainer = styled(Col)`
    max-width: calc(100% - 300px);
    width: auto;
    margin: 0 auto;
    /* padding-bottom: 10px;
    border-bottom: 1px solid ${(props) => HexToRgba(props.theme.white, 0.05)}; */
    a {
        /* color: ${(props) => props.headerColor === "white" ? props.theme.gray : props.theme.white}; */
        color: ${(props) => props.headerColor === "white" ? props.theme.gray : "#eee"};
        transition: all 500ms;
    }
    /* @media screen and (max-width: 1366px) {
        width: calc(100% - 290px);
    } */
`
export const ActionButton = styled.a`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 120px;
    height: 40px;
    background-color: ${(props) => props.theme.secondary};
    border: 1px solid ${(props) => props.theme.secondary};
    border-radius: 5px;
    color: ${(props) => props.theme.white};
    font-size: ${(props) => props.theme.fontSizeSm};
    font-weight: bold;
    cursor: pointer;
    transition: all 300ms;

    :hover {
        border: 1px solid ${(props) => DarkColorConstruction(props.theme.secondary, 40)};
        background-color: ${(props) => DarkColorConstruction(props.theme.secondary, 40)};
    }
`